var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.items),function(item){return _c('span',{key:'item-' + item.id,staticClass:"dossier-list--round-item",style:({ backgroundColor: '#' + item.color })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }